import React, { useState } from "react";
import Papa from "papaparse";

export interface CsvViewerProp {
    csv: string;
}
export function CsvViewer({ csv }: CsvViewerProp)
{
    const [data, setData] = useState<string[][] > ([]);

    React.useEffect(() => {
        Papa.parse(csv, {
            delimitersToGuess: [';', ',', '\t', '|'],
            // Détection automatique du délimiteur
            delimiter: "",
            skipEmptyLines: 'greedy',
            complete: (result: { data: string[][]; }) => {
                //console.log("Délimiteur détecté :", result.meta.delimiter);
                console.log("Données :", result.data);
                setData(result.data as string[][]);
            },
            error: (err: any) => console.error(err),
            });
    }, [csv]);

    return (
        <div style={{ padding: 20 }}>
            {data.length > 0 && (<table style={{ marginTop: 20, borderCollapse: "collapse" }}>
                <tbody>
                    {data.map((row, i) => (
                        <tr key={i}>
                            {row.map((cell, j) => (
                                <td key={j} style={{ border: "1px solid #ccc", padding: "6px 10px" }} >
                                    {cell}
                                </td>))}
                        </tr>))}
                </tbody>
            </table>)}
        </div>);
}